//* Libraries imports
import { BaseApiService } from "@services/baseApiService";
import { ApiResponse, ApiError } from "@/types/api";
import { api } from "@services/api";

//* Types imports
import type {
  TechinicalHistoryPayload,
  TechinicalHistoryOutputDTO,
  TechinicalHistoryListResponse,
  TechinicalHistoryFilters,
} from "./types";

class TechinicalHistoryService extends BaseApiService<TechinicalHistoryOutputDTO> {
  constructor() {
    super("techinicals-history");
  }

  async create(
    data: TechinicalHistoryPayload
  ): Promise<ApiResponse<TechinicalHistoryOutputDTO> | ApiError> {
    if (data.type === "upload" && data.file) {
      const formData = new FormData();
      if (data.techinicalId) formData.append("techinicalId", data.techinicalId);
      if (data.clientId) formData.append("clientId", data.clientId);
      formData.append("type", "upload");
      formData.append("file", data.file);

      return await api.uploadRequest<TechinicalHistoryOutputDTO>(
        `/${this.endpoint}`,
        formData
      );
    } else {
      return await super.create(data as any);
    }
  }

  async list(
    filters: TechinicalHistoryFilters = {}
  ): Promise<ApiResponse<TechinicalHistoryListResponse> | ApiError> {
    console.log(
      "📡 - TechinicalHistoryService.ts - Iniciando list com filtros:",
      filters
    );

    // Limpar filtros nulos ou indefinidos
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, v]) => v !== null && v !== undefined && v !== ""
      )
    );

    const queryString = new URLSearchParams(cleanFilters as any).toString();
    const url = `${this.baseUrl}${queryString ? `?${queryString}` : ""}`;

    return await api.request<TechinicalHistoryListResponse>(url);
  }

  async update(
    id: string,
    data: { mapping?: any; documentUrl?: string }
  ): Promise<ApiResponse<TechinicalHistoryOutputDTO> | ApiError> {
    return await super.update(id, data as any);
  }
}

export const techinicalHistoryService = new TechinicalHistoryService();
